import { ClassProp } from 'helpers/types';
import React, { FunctionComponent } from 'react';
import { Container, Placeholder } from 'semantic-ui-react';
import withStyles from 'react-jss';

type Props = {
  classes: ClassProp<typeof styles>;
};

const styles = {
  container: {
    backgroundColor: '#fff !important',
    borderRadius: '.375rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    margin: '.625rem 0 !important',
    padding: '1.25rem !important',
    width: '100% !important',
    position: 'relative !important',
  },
};

const OfferDetailsPlaceholder: FunctionComponent<Props> = ({ classes }) => (
  <Container className={classes.container}>
    <Placeholder>
      <Placeholder.Paragraph>
        <Placeholder.Line length="full" />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line length="full" />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </Placeholder>
  </Container>
);

export default withStyles(styles)(OfferDetailsPlaceholder);
